import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderAgencycsw = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();
const [tblletters, setTblletters] = useState([]);
const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({
	date1:''
	, date2:''
	});




const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "APS LC Letters";	

if (tblletters.length<1){
	gettblletters();
	}//end if
	//qrylabor();
 },[]);




function handleChange(e){
	
	const {name, value}=e.target;
console.log("handleChange name: "+name+' '+value);

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if



async function getlbrclrLetter(e, LBR_CLR_APP_ID, DEC_ID, PDF_SIZE, FILE_PATH){

e.preventDefault();

//console.log("e.target.id: "+e.target.id);
if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");

if (1*PDF_SIZE==0)
	window.alert("The pdf letter may not have been generated as yet.\r\nIf it does not download you can try again after 10 minutes");



   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {LBR_CLR_APP_ID:LBR_CLR_APP_ID, DEC_ID:DEC_ID, PDF_SIZE:PDF_SIZE, FILE_PATH:FILE_PATH} )
  };		

  await fetch(resturl+'rarwptprocess/getlbrclrLetter',requestOptions)
      .then(res => 	aftergetlbrclrLetter(res, e, LBR_CLR_APP_ID) )
      .catch(err => console.log(err));

}//end func


async function aftergetlbrclrLetter(res, e, LBR_CLR_APP_ID){

if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");

const blob = await res.blob();
//const blobBytesSize = blob.size;
console.log("blob.type: "+blob.type);

if (blob.type=="application/json"){
	let blob_text = await blob.text();
	console.log("blob_text: "+blob_text);
	const temp = JSON.parse(blob_text);
	const error=temp?(temp.error??""):"seems the file was not found on the server ";
	alert(error);
	}
else
	saveAs(blob, "LabourClearanceLetter"+LBR_CLR_APP_ID+".pdf");

}//end func	
	
function nagivatetolbrclrapp(e, LBR_CLR_APP_ID){

e.preventDefault();
const confd=window.confirm("You will be navigated away from this page to Labour Clearance page.  Ok?");
if (!confd)
	return;
	
navigate("/lbr_clr_app", {state:{BACK_PAGE:"lbr_clr_letter", IPM_LBR_CLR_APP_ID:LBR_CLR_APP_ID}});	
	
}//end func

async function gettblletters(){

let params = searchcrit;

console.log("gettblletters: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblletters([]);

  await fetch(resturl+'rarwptprocess/tbllbrclrletters',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblletters(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblletters(res){

if (!res.length)
	return;
	
let htmrows=[];

res.map((col, index) => {
	const trkey='tr_'+index;
	const rdkey='td_'+index;
	const LBR_CLR_APP_ID=col['LBR_CLR_APP_ID'];
	
	if (index==0)
		setSearchcrit({date1:col['DATE1'], date2:col['DATE2']});
	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='center' >{col['TC_DEC_DATE']}</td>
	<td align='center' >{col['CREATED_BY']}</td>
	<td align='center' ><a href="#" className="nodecor" onClick={(e)=>{nagivatetolbrclrapp(e, LBR_CLR_APP_ID);}}>{LBR_CLR_APP_ID}</a></td>
	<td align='left' ><a href="#" className="nodecor" id={trkey} onClick={(e)=>{getlbrclrLetter(e, LBR_CLR_APP_ID, col['DEC_ID'], col['PDF_SIZE'], col['FILE_PATH']);}}><img src="img/pdf.gif" border='0' /> {col['DECISION']}</a></td>
	<td align='center' >{col['REVERSAL']}</td>
	<td align='left' >{col['REVERSE_REASON']}</td>
	<td align='left' >{col['TC_EMAIL_SENT']}</td>
	<td align='left' title={col['EMAIL']} >{col['EMAIL_SHORT']}</td>
	<td align='left' >{col['MPR_NAME']}</td>
	<td align='left' >{col['MPE_NAME']}</td>
	<td align='left' >{col['OCCUPATION']}</td>
	</tr>;
	htmrows.push(htmrow);




});	

setTblletters(htmrows);	
}//end func



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;

if (!document.getElementById("btnsave").classList.contains("hidden"))
	document.getElementById("btnsave").classList.add("hidden");
		
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func




	
	

  return (
    <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
	Letters for Labour Clearance Applications Denied or Deferred
	</p>
	<div align="center" ><a href="#" onClick={(e)=>{e.preventDefault();navigate("/lbr_clr_app");}} className="nodecor" ><img src="img/return.png" border="0" /> return to labour clearance</a></div>
	<div align="center "style={{marginTop:"12px"}}  >
	<input name="date1" type="date" value={searchcrit.date1} onChange={(e)=>{handleChange(e);}} />&nbsp;&nbsp;
	<input name="date2" type="date" value={searchcrit.date2} onChange={(e)=>{handleChange(e);}} />&nbsp;&nbsp;
	<button className="button" onClick={(e)=>{gettblletters();}} >apply date filter</button>
	</div>
	<table align='center' className='customers' style={{marginTop:"12px",width:"95%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>Decision Date</th>
		<th>Decision By</th>
		<th>LC Id #</th>
		<th>Decision</th>
		<th>Reversal</th>
		<th>Reversal Reason</th>
		<th>Email Sent</th>
		<th>Email Address</th>
		<th>Employer Name</th>
		<th>Worker Name</th>
		<th>Occupation</th>
	</tr>
	</thead>

	<tbody>
		{tblletters}
	</tbody>
	</table>



<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderAgencycsw;